import { Dispatch } from 'react';
import { TableAction, TableSyncActions } from './types';
import { FiltersByGroup, TableResponse } from '../types';

const createSyncActions = (dispatch: Dispatch<TableAction>): TableSyncActions => ({
  setCurrentPage: (page: number) => {
    dispatch({ type: 'SET_CURRENT_PAGE', payload: page });
  },

  setPageSize: (size: number) => {
    dispatch({ type: 'SET_PAGE_SIZE', payload: size });
  },

  setSearchString: (search: string) => {
    dispatch({ type: 'SET_SEARCH_STRING', payload: search });
  },

  clearSearch: () => {
    dispatch({ type: 'CLEAR_SEARCH' });
  },

  setSorting: (field: string, direction: 'asc' | 'desc') => {
    dispatch({ type: 'SET_SORTING', payload: { field, direction } });
  },

  clearSorting: () => {
    dispatch({ type: 'CLEAR_SORTING' });
  },

  setFilter: (key: string, value: any) => {
    dispatch({ type: 'SET_FILTER', payload: { key, value } });
  },

  removeFilter: (key: string) => {
    dispatch({ type: 'REMOVE_FILTER', payload: key });
  },

  clearFilters: () => {
    dispatch({ type: 'CLEAR_FILTERS' });
  },

  selectItem: (id: string | number) => {
    dispatch({ type: 'SELECT_ITEM', payload: id });
  },

  deselectItem: (id: string | number) => {
    dispatch({ type: 'DESELECT_ITEM', payload: id });
  },

  selectAllItems: (ids: (string | number)[]) => {
    dispatch({ type: 'SELECT_ALL_ITEMS', payload: ids });
  },

  clearSelection: () => {
    dispatch({ type: 'CLEAR_SELECTION' });
  },

  resetTable: () => {
    dispatch({ type: 'RESET_TABLE' });
  },

  setLoading: (loading: boolean) => {
    dispatch({ type: 'SET_LOADING', payload: loading });
  },

  setLoadingFilters: (loading: boolean) => {
    dispatch({ type: 'SET_LOADING_FILTERS', payload: loading });
  },

  setError: (error: string | null) => {
    dispatch({ type: 'SET_ERROR', payload: error });
  },

  setData: (response: TableResponse<any>) => {
    dispatch({ type: 'SET_DATA', payload: response });
  },

  setFiltersReferential: (filters: FiltersByGroup[]) => {
    dispatch({ type: 'SET_FILTERS_REFERENTIAL', payload: filters });
  },

  updateLastFetchParams: () => {
    dispatch({ type: 'UPDATE_LAST_FETCH_PARAMS' });
  }
});

export default createSyncActions;
